import Vue from 'vue'
import App from '@/views/App.vue'
import getRouter from "@/router"
import store from '@/store/index'
import vueHelper from "@/vueHelper"
import Textbox from "@/components/textbox"
// import MobileSelectbox from "@/components/mobileSelectbox"
// import MobileTextbox from "@/components/mobileTextbox"
import Datebox from "@/components/datebox"
// import RichText from "@/components/richtext"
// import Datebox2 from "@/components/datebox2"
// import FileUpload from "@/components/fileupload"
import CheckBox from "@/components/checkbox"
// import SlickGrid from "@/components/SlickGrid"
// import DataFilter from "@/components/Filter"
// import RadioBox from "@/components/radiobox"
// import PageHeader from "@/components/PageHeader"
// import PageMobileHeader from "@/components/PageMobileHeader"
// import PageHeaderNoAction from "@/components/PageHeaderNoAction"
// import mbcheckBox from "@/components/mbcheckbox"
// import fbselectbox2 from "@/components/fbselectbox2"
// import fbdatetimebox from "@/components/fbdatetimebox"
import VueCountryCode from "vue-country-code-select";
import VueI18n from 'vue-i18n'


// import fbtextbox from "@/components/fbtextbox"
import msal from 'vue-msal'
import { msalMixin } from 'vue-msal';
import assetsConfig from "@/config"
import "./assets/icofont/icofont.css";
// import "./assets/scss/slickgrid-theme-bootstrap.scss";
// import axios from 'axios'
import {messages} from "./assets/js/lsstore.js";

let installHelper = (Vue, options) => {
  Vue.prototype.$helper = vueHelper;
}


async function init() {
  assetsConfig.serverURI = config.serverURI;
  assetsConfig.serverBase = config.serverBase;

  // console.log(assetsConfig.serverURI+assetsConfig.filePath);
  // await vueHelper.getConfig();

  // assetsConfig.sessionWarn = vueHelper.getParam("SESSION_WARNING") || assetsConfig.sessionWarn;
  // assetsConfig.sessionTimeout = vueHelper.getParam("SESSION_TIMEOUT") || assetsConfig.sessionTimeout;



  // console.log(assetsConfig.sessionWarn);
  Vue.config.productionTip = false

  Vue.use(installHelper);
  Vue.use(VueI18n);

  // if(vueHelper.getParam("msal_clientid")){
  //   Vue.use(msal, {
  //     auth: {
  //       clientId: vueHelper.getParam("msal_clientid"),
  //       graphScopes: ['user.read'],
  //       redirectUri: vueHelper.getParam("msal_redirect"),
  //       postLogoutRedirectUri: vueHelper.getParam("msal_logout_redirect")
  //     }
  //   });
  // }

  Vue.use(VueCountryCode);

  Vue.component('Textbox', Textbox)
  // Vue.component('MobileTextbox', MobileTextbox)
  Vue.component('Datebox', Datebox)
  // Vue.component('Datebox2', Datebox2)
  // Vue.component('FileUpload', FileUpload)
  Vue.component('CheckBox', CheckBox)
  // Vue.component('SlickGrid', SlickGrid)
  // Vue.component('DataFilter', DataFilter)
  // Vue.component('RadioBox', RadioBox)
  // Vue.component('PageHeader', PageHeader)
  // Vue.component('fbtextbox', fbtextbox)
  // Vue.component('PageMobileHeader', PageMobileHeader)
  // Vue.component('fbselectbox2', fbselectbox2)
  // Vue.component('PageHeaderNoAction', PageHeaderNoAction)
  // Vue.component('MobileSelectbox', MobileSelectbox)
  // Vue.component('mbCheckBox', mbcheckBox)
  // Vue.component('RichText', RichText)
  // Vue.component('fbdatetimebox', fbdatetimebox)

  // export const bus = new Vue();

  // let router = require('@/router');

  const i18n = new VueI18n({
    locale: store.getters.getAppLanguage, // set locale
    messages, // set locale messages
  })

  var mainVue = new Vue({
    i18n:i18n,
    el: '#app',
    mixins: [msalMixin],
    router:getRouter(),
    store,
    render: function (h) {
      return h(App)
    },
    // computed: {
    //   user() {
    //     let user = null;
    //     if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
    //       user = {
    //         ...this.msal.user,
    //         profile: {}
    //       }
    //       if (this.msal.graph && this.msal.graph.profile) {
    //           user.profile = this.msal.graph.profile
    //       }
    //     }
    //     console.log(user);
    //     return user;
    //   }
    // }
  })

}


init();